import {observer} from 'mobx-react-lite';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import CustomerQuoteFormStore from '../FormStore';

const QuoteVULFields = observer(({state}: {state: CustomerQuoteFormStore}) => {
    const errors = state.getQuoteErrors();

    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="Contribution"
                    defaultValue={state.quote.get('contribution')}
                    error={!!errors.contribution}
                    helperText={errors?.contribution}
                    onChange={(e) => {
                        state.setQuote('contribution', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    defaultValue={state.quote.get('spx')}
                    margin="normal"
                    label="SPX"
                    error={!!errors.spx}
                    helperText={errors?.spx}
                    onChange={(e) => {
                        state.setQuote('spx', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="VUL"
                    defaultValue={state.quote.get('vul')}
                    error={!!errors.vul}
                    helperText={errors?.vul}
                    onChange={(e) => {
                        state.setQuote('vul', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
        </Grid>
    );
});

export default QuoteVULFields;
